import React from 'react';
import { Avatar } from '@/components/ui/avatar';

interface ProductDrawerAvatarProps {
  imgAlt: string;
  img: string;
  title: string;
  subtitle: string;
}

export const ProductDrawerAvatar = ({ img, imgAlt, title, subtitle }: ProductDrawerAvatarProps) => {
  return (
    <div className="flex items-center gap-4">
      <Avatar variant="rounded" alt={imgAlt} src={img}></Avatar>
      <div className="flex flex-col">
        <p className="text-base leading-[150%] font-normal">{title}</p>
        <p className="text-sm">{subtitle}</p>
      </div>
    </div>
  );
};
